import clsx from "clsx";
import Wrapper from "../../Components/Layout/Wrapper";
import ShyTitleComponent from "../../Components/ShyTitleComponent";

import * as styles  from "./styles.module.scss";

export const Heading = ({ 
    level = 2, 
    size = "medium", 
    classes = '',
    text, 
    center = false,
    allCaps = false,
}) => {
    if (parseInt(level) < 1 || parseInt(level) > 6) {
        console.warn(`Heading level "${ level }" is not valid. It should be between 1 and 6.`);
        return null;
    }

    const Tag = `h${ level }`;

    return (
        <Wrapper>
            <Tag className={clsx(resolveSizeClass(size), classes, { 
                [styles.center]: center, 
                [styles.allCaps]: allCaps 
            })}><ShyTitleComponent text={text} /></Tag>
        </Wrapper>
    );
};

const resolveSizeClass = (size) => {
    switch(size) {
        case 'mini':
            return 'heading-mini';
        case 'small':
            return 'heading-small';
        case 'medium':
            return 'heading-medium';
        case 'large':
            return 'heading-large';
        case 'mega':
            return 'heading-mega';
        default:
            return 'heading-medium';
    }
}